import type {
  LeaderboardRow as LeaderboardRowData,
  LeaderboardViewerRank,
} from '@wineryxplorer/shared';
import { LeaderboardRow } from './LeaderboardRow';

interface ViewerRankCalloutProps {
  viewerRank: LeaderboardViewerRank;
  /** Resolved viewer profile bits we already have client-side for the row body. */
  viewer: {
    userId: string;
    userName: string;
    displayName: string;
    avatarUrl: string | null;
  };
}

/**
 * Sits below the top-25 table when the viewer is signed in, opted in,
 * and outside the cutoff. Reuses LeaderboardRow with the emphasis flag
 * so we don't duplicate visual logic.
 *
 * The viewer's most-recent check-in isn't returned by the leaderboard
 * procedure (it ships only what's needed for the ranked rows), so we
 * synthesize a row with mostRecentCheckIn: null. This keeps the
 * procedure surface small; we can extend it later if the row feels
 * empty without it.
 */
export const ViewerRankCallout = ({ viewerRank, viewer }: ViewerRankCalloutProps) => {
  const syntheticRow: LeaderboardRowData = {
    rank: viewerRank.rank,
    userId: viewer.userId,
    userName: viewer.userName,
    displayName: viewer.displayName,
    avatarUrl: viewer.avatarUrl,
    uniqueVenueCount: viewerRank.uniqueVenueCount,
    mostRecentCheckIn: null,
  };

  return (
    <div className="mt-8">
      <div className="px-3 md:px-4 mb-2">
        <span className="font-sans text-xs uppercase tracking-wide text-gray-600">
          Your rank
        </span>
      </div>
      <LeaderboardRow row={syntheticRow} emphasis />
    </div>
  );
};
